import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'redux-form';
import { Theme, colors } from '../../../legacy/hui/src/styled/theme';
import { Theme as ThemeBunnings } from '../Bunnings/Theme';
import { Row, Col } from '../../../legacy/hui/src/styled';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import dateIcon from '../../images/date-icon.svg';

import { formatDate, parseDate } from 'react-day-picker/moment';

export const Radio = styled(Field)`
  display: none;
`;

const DayPickerInputWrapper = styled.div`
  position: relative;
  .DayPickerInput {
    width: 100%;
    padding-right: 10px;
  }

  input {
    width: 100%;
    font-size: 16px;
    border-radius: 4px;
    appearance: none;
    outline: 0;
    border: 1px solid #b4b4b5;
    padding: 11px 20px;
    background-image: url(${dateIcon});
    background-repeat: no-repeat;
    background-position: right 10px center;
  }
`;

const RadioOption = styled.div`
  display: inline-block;
  margin: 0 5px 5px 0;

  input[type='radio']:checked + label {
    background: ${ThemeBunnings.primary};
    color: ${Theme.snow};
    border-color: ${ThemeBunnings.primary};
  }
`;

const AnswerLabel = styled.label`
  cursor: pointer;
  padding: 10px 15px;
  border: 1px solid ${colors.GREY};
  border-radius: 100px;
  background-color: ${Theme.snow};
  color: ${colors.MEDIUM_DARK_GREY};
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
`;

const times = ['8am - 12pm', '12pm - 5pm', 'Anytime'];

const now = new Date().getTime() + 86400000;
const nextDay = new Date(now);

const DatePickField = ({ input, onDatePicked, optionKey }) => ( // eslint-disable-line
  <DayPickerInput
    format="DD/MM/YYYY"
    inputProps={{ ...input }}
    placeholder="Select a date"
    formatDate={formatDate}
    parseDate={parseDate}
    dayPickerProps={{ disabledDays: { before: nextDay } }}
    onDayChange={day => {
      onDatePicked(formatDate(day), optionKey);
    }}
  />
);

export class CustomTime extends React.Component {
  static propTypes = {
    input: PropTypes.object,
    optionKey: PropTypes.number,
    onDatePicked: PropTypes.func
  };

  constructor() {
    super();
  }

  render() {
    const { optionKey, onDatePicked } = this.props;
    const nameDate = `custom_date_${optionKey}`;
    const nameTime = `custom_time_${optionKey}`;

    return (
      <Row gutter={0} pb={'10px'}>
        <Col xs={12} md={4} gutter={0}>
          <DayPickerInputWrapper>
            <Field
              name={nameDate}
              onDatePicked={onDatePicked}
              optionKey={optionKey}
              component={DatePickField}
            />
          </DayPickerInputWrapper>
        </Col>
        <Col xs={12} md={8} gutter={0} pt={{ xs: 0.5, sm: 0.2 }}>
          {times.map((value, index) => {
            return (
              <RadioOption key={value}>
                <Radio
                  type="radio"
                  name={nameTime}
                  id={`${nameTime}_${index}`}
                  value={value}
                  component={({ input, ...rest }) => {
                    return <input {...input} {...rest} />;
                  }}
                />

                <AnswerLabel key={value} htmlFor={`${nameTime}_${index}`}>
                  {value}
                </AnswerLabel>
              </RadioOption>
            );
          })}
        </Col>
      </Row>
    );
  }
}
